/* ---------------------------------------- [START] isInViewport */
function isInViewport(el) {
	var rect = el.getBoundingClientRect();

	var isVisible = el.offsetHeight !== 0;

	return (
		isVisible &&
		rect.bottom >= 0 &&
		rect.right >= 0 &&
		rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
		rect.left <= (window.innerWidth || document.documentElement.clientWidth)
	);
}
/* ---------------------------------------- [END] isInViewport */

/* ---------------------------------------- [START] 簡單的節流函數 */
// https://www.cnblogs.com/coco1s/p/5499469.html
function throttle(func, wait, mustRun) {
	var timeout;
	var startTime = new Date();

	return function () {
		var context = this;
		var args = arguments;
		var curTime = new Date();

		if (timeout !== undefined) {
			if (window.requestTimeout !== undefined) clearRequestTimeout(timeout);
			else clearTimeout(timeout);
		}
		// 如果達到了規定的觸發時間間隔，觸發 handler
		if (curTime - startTime >= mustRun) {
			func.apply(context, args);
			startTime = curTime;
			// 沒達到觸發間隔，重新設定定時器
		} else {
			if (window.requestTimeout !== undefined) timeout = requestTimeout(func, wait);
			else timeout = setTimeout(func, wait);
		}
	};
}
/* ---------------------------------------- [END] 簡單的節流函數 */

(function(window, document) {

	/* ----------------------------------- [START] Windows Setting */
	const html = document.documentElement;
	// const body = document.body || document.querySelector('body');
	let ww = window.innerWidth;
	let wh = window.innerHeight;
	let ws = 0;
	function getScrollTop(target = window) {
		return (target.pageYOffset || html.scrollTop) - (html.clientTop || 0);
	}
	function getWinSet() {
		ww = window.innerWidth;
		wh = window.innerHeight;
		ws = getScrollTop();
	}
	window.addEventListener('load', getWinSet);
	window.addEventListener('resize', throttle(getWinSet, 50, 100));
	/* ----------------------------------- [END] Windows Setting */

	/* ----------------------------------- [START] 取得裝置判斷 */
	// 取得裝置判斷
	var isMobile = false;
	var isTablet = false;
	var isPhone = false;
	var deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
		if (isMobile) html.classList.add('is-mobile');
		else html.classList.remove('is-mobile');

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true;
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true;
		}
	};
	deviceDetect();
	on(window, 'resize', throttle(deviceDetect, 50, 100));
	/* ----------------------------------- [END] 取得裝置判斷 */
	/* ---------------------------------------- [START] 整頁 Scroll 監測 (Before) */
	var pageScrollCheckList = []; // 紀錄物件
	var pageScrollAdd = function (selector, buildFunction) {
		var el = document.querySelector(selector);
		if (el === null) {
			return false;
		}
		pageScrollCheckList.push({
			build: false,
			el: el,
			fun: buildFunction,
		});
	};
	var pageScrollClean = function () {
		pageScrollCheckList = Array.prototype.filter.call(pageScrollCheckList, function (item) {
			return item.build === false;
		});
	};
	/* ---------------------------------------- [END] 整頁 Scroll 監測 (Before) */

	/* ---------------------------------------- [START] 錨點點擊 */
	// 因為產品介紹（上稿區）的圖片有 Lazy Load，圖片無法先預設圖片大小，
	// 所以錨點在第一次點擊時會有位置上的差異
	function pdMenuBuild() {
		const pdMenu = document.querySelector('#page-nav-pd-cont');
		const $pdMenu = $(pdMenu);
		const pdMenuItem = pdMenu.querySelectorAll('a');
		// const pdMenuSmoothScrollOffset = pdMenu.dataset['offset'] || 110; // 讀取設定在<ul>上的 data-offset

		const pdIntro = document.querySelector('#pd-intro');
		const pdIntroOffset = pdIntro.getBoundingClientRect().top;
		const pdIntroImgs = pdIntro.querySelectorAll('img.lazyload'); // 上稿區的圖片
		
		let timer = null;
		let timerLoad = null;

		let targetHash = null; // 紀錄去哪個項目

		const imgLoadHandler = function() {
			if (timer) {
				clearTimeout(timer);
				timer = null;
			}

			if (timerLoad) {
				clearTimeout(timerLoad);
				timerLoad = null;
			}

			timer = setTimeout(() => {
				$pdMenu.foundation('reflow');

				$('[data-magellan]').foundation('scrollToLoc', targetHash);

				timerLoad = setTimeout(() => {
					if (timer) {
						clearTimeout(timer);
						timer = null;

						pdIntroImgs.forEach((img) => {
							// 等圖片讀取完 => 重新滑動
							img.removeEventListener('load', imgLoadHandler);
						});
					}
				}, 500);
			}, 100);
		}

		const clickHandler = function() {
			targetHash = this.hash;

			pdMenuItem.forEach((item) => {
				item.removeEventListener('click', clickHandler);
			});

			// 等圖片讀取完 => 重新滑動
			pdIntroImgs.forEach((img) => {
				img.addEventListener('load', imgLoadHandler);
			});
		}

		pdMenuItem.forEach((item) => {
			const sec = item.hash ? document.querySelector(item.hash) : null;

			if (item.hash && sec) {
				item.addEventListener('click', function() {
					this.blur();

					// data-magellan 重新計算
					$pdMenu.foundation('reflow');
				});

				// 判斷是否在 產品介紹（上稿區） 下方區塊
				if (pdIntroOffset < sec.getBoundingClientRect().top) {
					item.addEventListener('click', clickHandler);
				} else {
					// 在上方的區塊則要取消圖片
					item.addEventListener('click', function() {
						pdIntroImgs.forEach((img) => {
							img.removeEventListener('load', imgLoadHandler);
						});
					});
				}

				// 是第一個選項(overflow)
				// UAT 249 - 修正有時選擇Overflow無法正常顯示Active
				if (item.hash === '#pd-overflow') {
					item.addEventListener('click', function() {
						setTimeout(function() {
							// $('[data-magellan]').foundation('reflow');
							$pdMenu.foundation('reflow');
						}, 600)
					})
				}
			}
		});

		// UAT 249
		// 2022/04/20 不明原因，Chrome, Edge, Safari 沒有辦法觸發 Foundation magellan 模組的內建的事件，造成模組損壞，所以另外重設 loaded + scroll。
		// ※用空白頁製作 magellan 仍然是正常的。
		if (!document.documentElement.classList.contains('firefox')) {
			// $('[data-magellan]').foundation('reflow');
			$pdMenu.foundation('reflow');
			window.addEventListener('scroll', function() {
				// $('[data-magellan]').foundation('reflow');
				$pdMenu.foundation('reflow');
			})
		}
	}

	window.addEventListener('load', pdMenuBuild);
	/* ---------------------------------------- [END] 錨點點擊 */

	/* ---------------------------------------- [START] Other Channels */
	// Other Channels 一直打開收合動作會有不明無法移動 scroll bar 情況
	// 用 JS 操作 Scroll bar
	function channelPopupBuild() {
		const channel = $('#popup-channel')
		const channelScrollArea = channel.find('.fixed-panel__body');

		// Fires immediately before the modal opens. Closes any other modals that are currently open
		channel.on('closeme.zf.reveal', function() {
			// 關閉Scroll
			if (isMobile) {
				window.docDisableScroll && docDisableScroll();
			}
			
			setTimeout(() => {
				channelScrollArea.scrollTop(0);
				channelScrollArea.focus();
			}, 10);
		});

		// Fires when the modal is done closing.
		channel.on('closed.zf.reveal', function() {
			// 開啟Scroll
			if (isMobile) {
				window.docEnableScroll && docEnableScroll();
			}
		});
	}
	window.addEventListener('load', channelPopupBuild);
	/* ---------------------------------------- [END] Other Channels */

	/* ---------------------------------------- [START] Share to SNS */
	var anchors = document.querySelectorAll('.sharer');
	[].forEach.call(anchors, function (anchor) {
		anchor.addEventListener(
			'click',
			function (e) {
				e.preventDefault();

				var target = e.currentTarget;

				// Get title
				var articleTitle = document.querySelector('#article-title')
					? document.querySelector('#article-title').innerText
					: document.title;

				// change title to encode
				articleTitle = encodeURI(articleTitle);

				var hashTags = target.getAttribute('data-hashtags') || ''

				// grab the base sharing URL
				var url = target.href;

				// Change "{articleUrl}" to page url
				var shareUrl = url
					.replace(/CarticleUrlC/gm, window.location.href)
					.replace(/CarticleTitleC/gm, articleTitle)
					.replace(/ChashtagsC/gm, hashTags);

				// grab the name we want to give the window (parameter 2 on window.open)
				// MDN: 新視窗的名稱。該字元串可以用來作為超連結 <a> 或表單 <form> 元素的目標屬性值。字元串中不能含有空白字元。注意：strWindowName 並不是新視窗的標題。
				var windowName = target.getAttribute('data-windowName') || 'Share';
				windowName.replace(/\s/g, ''); // 移除空白

				// Grab parameter 3 for window.oprn (window settings)
				var windowSettings =
					target.getAttribute('data-settings') ||
					'menubar=no,toolbar=no,resizable=no,scrollbars=yes,height=700,width=550';

				// call window.open
				var otherWindow = window.open(shareUrl, windowName, windowSettings);
				otherWindow.opener = null;
				// otherWindow.location = shareUrl;
			},
			false
		);
	});
	/* ---------------------------------------- [END] Share to SNS */

	/* ---------------------------------------- [START] Navigator Share */
	/* 條件：一定要是HTTPS環境下才可以使用
	 * Ref: https://w3c.github.io/web-share/
	 */
	var shareButton = document.querySelectorAll('.js-navigator-share');
	// var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	[].forEach.call(shareButton, function (el) {
			// 要隱藏的項目（相同功能物件）
		const hideEl = (el.dataset && el.dataset['hideEl']) ? document.querySelector(el.dataset['hideEl']) : null; // 要隱藏的項目
		
		if (!isMobile || !navigator.share) {
			// 將非 Mobile 裝置、不支援 navigator share 擋下
			el.classList.add('hide'); // Hide Class
			el.tabIndex = -1;

			// 要隱藏的項目（相同功能物件）
			hideEl && hideEl.classList.remove('hide');
		} else {
			el.classList.remove('hide');
			
			// 要隱藏的項目（相同功能物件）
			hideEl && hideEl.classList.add('hide');
		}

		el.addEventListener('click', function (event) {
			if (navigator.share) {
				navigator
					.share({
						title: document.title,
						url: location.href,
					})
					.catch(console.error);
			}
		});
	});
	/* ---------------------------------------- [END] Navigator Share */

	/* ---------------------------------------- [START] Copy link */
	/* clipboard.js — Copy to clipboard without Flash
	 * https://clipboardjs.com/
	 */

	// 訊息由Toastr取代
	// var successMsg;
	// var clipTimer = null;

	/* 複製成功訊息 */
	// function addCopySuccess(text) {
	// 	if (successMsg === undefined) {
	// 		successMsg = document.createElement('div');
	// 		successMsg.className = 'copysuctip';
	// 		// successMsg.innerText = '複製成功';
	// 		successMsg.setAttribute('aria-live', 'assertive');
	// 	}
	// 	successMsg.innerText = text || '複製成功';
	// 	document.body.appendChild(successMsg);

	// 	// Remove
	// 	clearTimeout(clipTimer);
	// 	clipTimer = null;
	// 	clipTimer = setTimeout(function () {
	// 		successMsg.remove();
	// 		clipTimer = null;
	// 	}, 3000);
	// }

	function buildClipboardJS() {
		if (window.ClipboardJS !== undefined) {
			var clipboard = new ClipboardJS('.js-copy-link', {
				text: function (trigger) {
					var text = window.location.href;
					return text;
				},
			});

			clipboard.on('success', function (e) {
				e.clearSelection();
				toast('success', e.trigger.getAttribute('data-success'));
				e.trigger.blur();
			});
		}
	}
	window.addEventListener('load', buildClipboardJS);
	/* ---------------------------------------- [END] Copy link */

	/* ---------------------------------------- [START] Swiper Tool - Custom Animation */
	/* [START] Custom Animation */
	// Ref: https://codepen.io/udovichenko/pen/LGeQae

	// 客製化
	// interleaveOffset: 移動方向、程度：
	var customEffect = {
		onProgress: function (swiper, progress, interleaveOffset = 0.5, dir = 'h', imgSelector = 'img') {
			for (var i = 0; i < swiper.slides.length; i++) {
				var slideProgress = swiper.slides[i].progress;
				var innerOffset = swiper.width * interleaveOffset;
				var innerTranslate = slideProgress * innerOffset;
				swiper.slides[i].querySelector(imgSelector).style.transform = dir === 'v'
					? 'translate3d(0, ' + innerTranslate + 'px, 0)'
					: 'translate3d(' + innerTranslate + 'px, 0, 0)';
			}
		},

		onTouchStart: function (swiper) {
			for (var i = 0; i < swiper.slides.length; i++) {
				swiper.slides[i].style.transition = '';
			}
		},

		onSetTransition: function (swiper, speed, imgSelector = 'img') {
			for (var i = 0; i < swiper.slides.length; i++) {
				swiper.slides[i].style.transition = speed + 'ms';
				swiper.slides[i].querySelector(imgSelector).style.transition = speed + 'ms';
			}
		},
	};
	/* [END] Custom Animation */
	/* ---------------------------------------- [END] Swiper Tool - Custom Animation */

	/* ---------------------------------------- [START] Swiper Tool - CountDown */
	/** Swiper 倒數用的 SVG <circle> 物件
	 * 預設值是為了 Pagination 的 bullet 設置
	 * @param {Object} size - 傳入想要顯示的尺寸，預設 20
	 * @param {Object} width - 傳入顯示的粗細（可能會因為svg本身的縮放有些微差異），預設 4
	 */
	 var countdownCircle = function(size, width) {
		size = size || 20 + 2;
		width = width || 4;
		return `<svg class="countdown-circle-svg pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="${size}px" height="${size}px"><circle r="15.915" cy="18" cx="18" fill="none" stroke="currentColor" stroke-width="${width}" stroke-dasharray="100" stroke-dashoffset="100"></circle></svg>`;
	}

	/** Swiper 倒數用的 init function，on init 時執行
	 * @param {Object} swiper - 傳入 swiper
	 */
	function swiperCountdownInit (swiper) {
		var offset = 100; // <circle> 線段長度

		swiper.cd = {
			req: null, // 裝載 requestAnimationFrame
			el: null, // buttlet 的 <circle> 物件
			arrow: null, // swiperNextEl 物件(有倒數才要)
			start: null, // 記住開始的時間
			dur: swiper.params.autoplay.delay // 動畫進行多久(Autoplay Delay)
		}

		swiper.cd.perFrame = offset / swiper.cd.dur; // 動畫每 frame，更改多少 <circle> 線段長度

		swiper.cd.play = function(timestamp) {
			if (!swiper.cd.start) swiper.cd.start = timestamp;
			var progress = timestamp - swiper.cd.start; // 毫秒
			if (swiper.autoplay.running && progress < swiper.cd.dur) {
				var strokeDashoffset = offset - (swiper.cd.perFrame * progress);
				swiper.cd.el.style.strokeDashoffset = strokeDashoffset;
				swiper.cd.arrow && (swiper.cd.arrow.style.strokeDashoffset = strokeDashoffset);
				swiper.cd.req = window.requestAnimationFrame(swiper.cd.play);
			}
		}

		swiper.cd.stop = function() {
			cancelAnimationFrame(swiper.cd.req);
		}
	}

	/** Swiper 倒數用的 play function
	 * slideChange, autoplayStart 時執行
	 * autoplayStart 執行時，要設置 type 為 'start'
	 * @param {Object} swiper - 傳入 swiper
	 * @param {String} type - 輸入['start']為一開始進行動畫，之後的倒數都會因為 slide change transition 而有延遲
	 */
	function swiperCountdownPlay (swiper, type) {
		/* Reset Setting */
		swiper.cd.stop();
		swiper.cd.el && (swiper.cd.el.style.strokeDashoffset = ''); // 移除上一個的樣式
		swiper.cd.arrow && (swiper.cd.arrow.style.strokeDashoffset = ''); // 移除箭頭上的倒數
		swiper.cd.el = swiper.pagination.bullets[swiper.realIndex].querySelector('circle'); // 尋找 circle 物件
		swiper.cd.start = null; // 設定開始時間

		/* Start Animation */
		if (type === 'start') {
			// 如果是一開始 init 進行 (沒有更換 slide 的延遲)
			swiper.cd.req = requestAnimationFrame(swiper.cd.play);
		} else {
			// 具有更換 slide transition 的延遲
			setTimeout(function() {
				swiper.cd.req = requestAnimationFrame(swiper.cd.play);
			}, swiper.params.speed)
		}
	}

	function swiperCountdownStop (swiper) {
		swiper.cd.stop();
	}
	/* ---------------------------------------- [END] Swiper Tool - CountDown */

	let pdPhotoSwiper = null; // 紀錄 Photo 的 Swiper
	// （因為Photo Swipe(Mobile 燈箱)項目也要Call，所以放這）

	/* ---------------------------------------- [START] Product Photo - Popup (Photo Swiper)  */
	// Doc: https://photoswipe.com/documentation/getting-started.html
	var items = []; // Item array
	function photoSwipeOpen(itemIndex, selector) {
		var pswpElement = document.querySelectorAll('.pswp')[0];

		var options = {
			history: false,
			focus: false,
			showAnimationDuration: 0,
			hideAnimationDuration: 0,
			index: itemIndex || 0, // start at first slide
			getThumbBoundsFn: function (itemIndex) {
				var thumbnail = items[itemIndex].el;
				var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
				var rect = thumbnail.getBoundingClientRect();
				return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
			},
		};

		var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

		// Get Unknow Size
		// https://stackoverflow.com/a/40525732/11240898
		gallery.listen('gettingData', function (index, item) {
			if (item.w < 1 || item.h < 1) {
				// unknown size
				var img = new Image();
				img.onload = function () {
					// will get size after load
					item.w = this.width; // set image width
					item.h = this.height; // set image height
					gallery.invalidateCurrItems(); // reinit Items
					gallery.updateSize(true); // reinit Items
				};
				img.src = item.src; // let's download image
			}
		});

		// Event fire when Gallery starts closing
		gallery.listen('close', function() { 
			// 結束時，更換Swiper到目前項目
			pdPhotoSwiper && pdPhotoSwiper.slideToLoop(gallery.getCurrentIndex());
		});

		gallery.init();
	}

	function photoSwipeInit() {
		var selector = '#pd-photo-carousel img';
		var galleryImg = document.querySelectorAll(selector);

		[].forEach.call(galleryImg, function (item, index) {
			item.index = index;
			item.setAttribute('draggable', false);

			// 讀取圖片資料
			var src = item.getAttribute('data-src') || item.getAttribute('src');
			if (src) {
				items.push({
					el: item,
					src: src,
					w: 0,
					h: 0,
				});
			}

			item.addEventListener('click', function () {
				photoSwipeOpen(item.index);
			});
		});
	}
	/* ---------------------------------------- [END] Product Photo - Popup (Photo Swiper)  */

	/* ---------------------------------------- [START] Product Photo  */
	const pdPhotoCarousel = '#pd-photo-carousel'; // .swiper-container id

	function pdPhotoBuild() {
		const swiperTarget = pdPhotoCarousel;
		const swiperEl = document.querySelector(swiperTarget).parentElement;
		const swiperContEl = document.querySelector(swiperTarget);
		const swiperPageEl = swiperEl.querySelector('.swiper-pagination');
		const swiperNextEl = swiperEl.querySelector('.swiper-button-next');
		const swiperPrevEl = swiperEl.querySelector('.swiper-button-prev');
		const swiperCtrlEl = swiperEl.querySelector('.swiper-ctrl');

		// 是否要Loop
		const isLoop = swiperEl.querySelectorAll('.swiper-slide').length > 1;

		// 非Loop => 隱藏控制
		if (!isLoop) {
			swiperCtrlEl.classList.add('hide');
		}

		// ===================================
		// 滑鼠移動
		// How To - Image Zoom: https://www.w3schools.com/howto/howto_js_image_zoom.asp
		let img; // 目前的圖片
		let imgCache;
		let imgViewer;
		let cx, cy, originW, originH;
		let zoomScale = 1.5; // 初始
		let zoomScaleMin = 1;
		let zoomScaleMax = 1.5;
		let wheelEnable = false; // 滾輪放大縮小是否啟動
		let resultPosAdjustTop = 0; // 預覽結果(右)調整的上方位置（如果圖片不是1:1）
		let resultPosAdjustLeft = 0; // 預覽結果(右)調整的左側位置（如果圖片不是1:1）
		let previewImgWidth = 0; // 預覽相冊（左）大小（用來比對Len放大框的位置）
		let previewImgHeight = 0; // 預覽相冊（左）大小（用來比對Len放大框的位置）
		let previewImgTop = 0; // 預覽相冊（左）上方距離（用來比對Len放大框的位置）
		let previewImgLeft = 0; // 預覽相冊（左）左側距離（用來比對Len放大框的位置）
		let previewImgLimit = true; // Len 的移動是否限制於圖片大小
		const classIsHover = 'is-zooming';

		const lens = swiperEl.querySelector('.pd-photo__img-zoom-lens');
		const result = document.querySelector('#pd-photo-zoom-result');

		const pdOverviewCont = document.querySelector('.pd-overview__cont');

		function zoomSetImg(sw) {
			// 設定歸零
			resultPosAdjustTop = 0;
			resultPosAdjustLeft = 0;

			sw = sw || pdPhotoSwiper;
			img = sw.slides[sw.activeIndex].querySelector('img');

			/* Set background properties for the result DIV */
			result.style.backgroundImage = "url('" + img.src + "')";
			if (imgCache !== img) {
				imgCache = img;
				// 新的
				imgViewer = document.createElement('img');
				imgViewer.onload = function() {
					resultImgDataGet();

					// 取得左側圖片資料
					previewImgWidth = img.width;
					previewImgHeight = img.height;
					previewImgTop = 0;
					previewImgLeft = 0;
					if (imgViewer.naturalWidth > imgViewer.naturalHeight) {
						// 寬圖
						previewImgHeight = img.width * imgViewer.naturalHeight / imgViewer.naturalWidth;
						previewImgTop = (previewImgWidth - previewImgHeight) / 2;
					} else if (imgViewer.naturalWidth < imgViewer.naturalHeight) {
						// 高圖
						previewImgWidth = img.height * imgViewer.naturalWidth / imgViewer.naturalHeight;
						previewImgLeft = (previewImgHeight - previewImgWidth) / 2;
					}
				}
				imgViewer.src = img.src;
			} else {
				// 舊的
				resultImgDataGet();
			}
		}

		// 取得預覽圖片資料
		function resultImgDataGet() {
			let backgroundSizeWidth = img.width * cx;
			let backgroundSizeHeight = img.height * cy;
			if (imgViewer.naturalWidth > imgViewer.naturalHeight) {
				// 寬圖
				backgroundSizeHeight = (img.width * imgViewer.naturalHeight / imgViewer.naturalWidth) * cy;
				resultPosAdjustTop = (imgViewer.naturalWidth - imgViewer.naturalHeight) / 2 * (img.width / imgViewer.naturalWidth); // 調整預視圖位置：邊長差 / 2 * 與原圖縮放比例
			} else if (imgViewer.naturalWidth < imgViewer.naturalHeight) {
				// 高圖
				backgroundSizeWidth = (img.height * imgViewer.naturalWidth / imgViewer.naturalHeight) * cx;
				resultPosAdjustLeft = (imgViewer.naturalHeight - imgViewer.naturalWidth) / 2 * (img.height / imgViewer.naturalHeight); // 調整預視圖位置：邊長差 / 2 * 與原圖縮放比例
			}
			result.style.backgroundSize = (backgroundSizeWidth) + "px " + (backgroundSizeHeight) + "px";
		}

		// START ======>
		function mouseEnable() {
			// Lens 的原始設定大小
			originW = lens.offsetWidth;
			originH = lens.offsetHeight;

			scaleLen(zoomScale);

			/* Execute a function when someone moves the cursor over the image, or the lens: */
			swiperContEl.addEventListener('mouseenter', mouseenter);
			swiperContEl.addEventListener('mouseleave', mouseleave);
			swiperContEl.addEventListener('mousemove', moveLens);
			if (wheelEnable) {
				swiperContEl.addEventListener('wheel', wheel);
			}
		}

		function mouseenter() {
			swiperEl.classList.add(classIsHover);
			pdOverviewCont.classList.add(classIsHover);
		}

		function mouseleave() {
			swiperEl.classList.remove(classIsHover);
			pdOverviewCont.classList.remove(classIsHover);
		}

		function scaleLen(scale) {
			lens.style.width = originW * scale + 'px';
			lens.style.height = originH * scale + 'px';

			cx = result.offsetWidth / lens.offsetWidth;
			cy = result.offsetHeight / lens.offsetHeight;
		}

		// Scale Ref: https://codepen.io/mstaniuk/pen/rrZVpG
		function wheel(event) {
			event.preventDefault();
			if (event.deltaY > 0) {
				// 往下滑 => 縮小(放大顯示區域)
				if(zoomScale < zoomScaleMax) {
					zoomScale += 0.1;
					scaleLen(zoomScale);
					zoomSetImg();
					moveLens(event);
				}
			}
			else {
				// 往上滑 => 放大(縮小顯示區域)
				if(zoomScale > zoomScaleMin) {
					zoomScale -= 0.1;
					scaleLen(zoomScale);
					zoomSetImg();
					moveLens(event);
				}
			}
		}

		function moveLens(e) {
			
			var pos, x, y;

			/* Prevent any other actions that may occur when moving over the image */
			e.preventDefault();

			/* Get the cursor's x and y positions: */
			pos = getCursorPos(e);

			/* Calculate the position of the lens: */
			x = pos.x - (lens.offsetWidth / 2);
			y = pos.y - (lens.offsetHeight / 2);

			// 如果有限制於圖片大小
			if (previewImgLimit) {
				// X
				if (previewImgWidth > lens.offsetWidth) {
					// 圖片寬 > Len 寬
					if (x > previewImgWidth + previewImgLeft - lens.offsetWidth) { x = previewImgWidth + previewImgLeft - lens.offsetWidth; }
					if (x < previewImgLeft) { x = previewImgLeft }
				} else {
					// 圖片寬 < Len 寬 => 置中
					x = previewImgLeft - (lens.offsetWidth - previewImgWidth) / 2
				}

				// Y
				if (previewImgHeight > lens.offsetHeight) {
					// 圖片高 > Len 高
					if (y > previewImgHeight + previewImgTop - lens.offsetHeight) { y = previewImgHeight + previewImgTop - lens.offsetHeight; }
					if (y < previewImgTop) {y = previewImgTop;}
				} else {
					// 圖片高 < Len 高 => 置中
					y = previewImgTop - (lens.offsetHeight - previewImgHeight) / 2;
				}
			} else {
				/* Prevent the lens from being positioned outside the image: */
				if (x > img.width - lens.offsetWidth) {x = img.width - lens.offsetWidth;}
				if (x < 0) {x = 0;}
				if (y > img.height - lens.offsetHeight) {y = img.height - lens.offsetHeight;}
				if (y < 0) {y = 0;}
			}

			/* Set the position of the lens: */
			lens.style.left = x + "px";
			lens.style.top = y + "px";

			/* Display what the lens "sees": */
			result.style.backgroundPosition = ((x * cx) * -1 + resultPosAdjustLeft * cx) + "px " + ((y * cy) * -1 + resultPosAdjustTop * cy) + "px";
		}
	
		function getCursorPos(e) {
			var a, x = 0, y = 0;
			e = e || window.event;

			/* Get the x and y positions of the image: */
			a = img.getBoundingClientRect();

			/* Calculate the cursor's x and y coordinates, relative to the image: */
			x = e.pageX - a.left;
			y = e.pageY - a.top;

			/* Consider any page scrolling: */
			x = x - window.pageXOffset;
			y = y - window.pageYOffset;
			return {x : x, y : y};
		}
		// ===================================

		// 啟動相對應的圖片放大機制
		let isUseMouse = !isMobile && ww >= 1024;
		if (isUseMouse) {
			// PC(1024+): 滑鼠移動放大
			mouseEnable();
		} else {
			//  Mobile: 圖片燈箱
			photoSwipeInit();
		}

		// ===================================

		pdPhotoSwiper = new Swiper(swiperTarget, {
			spaceBetween: 50,
			loop: isLoop,
			simulateTouch: isLoop,
			lazy: {
				loadPrevNext: true,
			},
			preloadImages: false,
			watchSlidesProgress: true,
			// [START] Global Pagination + Button (Prev, Next)
			pagination: {
				el: isLoop ? swiperPageEl : null,
				type: 'fraction',
			},
			navigation: {
				nextEl: isLoop ? swiperNextEl : null,
				prevEl: isLoop ? swiperPrevEl : null,
			},
			// [END] Global Pagination + Button (Prev, Next)
			on: {
				// Custom Effect
				// Ref: https://codepen.io/udovichenko/pen/LGeQae
				progress(swiper, progress) {
					customEffect.onProgress(swiper, progress);
				},

				touchStart: function (swiper) {
					customEffect.onTouchStart(swiper);
				},

				setTransition(swiper, transition) {
					customEffect.onSetTransition(swiper, transition);
				},

				slideChange: function(swiper) {
					if (isUseMouse) {
						zoomSetImg(swiper);
	
						// 讀取紀錄
						const img = swiper.slides[swiper.activeIndex].querySelector('img');
						lenAdjustTop = img.lenTop || 0;
						lenAdjustLeft = img.lenLeft || 0;
					}
				},

				lazyImageReady: function(swiper, slideEl, imageEl) {
					if (isUseMouse) {
						if (swiper.realIndex === (swiper.slides.length === 1 ? 0 : parseInt(slideEl.dataset.swiperSlideIndex))) {
							zoomSetImg(swiper);
						}
					}
				}
			}
		});
	}

	window.addEventListener('load', function () {
		pageScrollAdd(pdPhotoCarousel, pdPhotoBuild);
	});
	/* ---------------------------------------- [END] Product Photo */

	/* ---------------------------------------- [START] Product Solution | 產品情境 */
	const pdSoluCarousel = '#pd-solu-carousel'; // .swiper-container id

	function pdSoluBuild() {
		const swiperTarget = pdSoluCarousel;
		const swiperContEl = document.querySelector(swiperTarget);
		const swiperEl = swiperContEl.parentElement;
		const swiperSlideEl = swiperEl.querySelectorAll('.swiper-slide');
		const swiperPageEl = swiperEl.querySelector('.swiper-pagination');

		const slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;
		const isLoop = slidesCount > 1;

		let swiper;

		// 建立 Solution Swiper 的公式
		const pdSoluSwiperBuild = function(opt) {
			const defaultOpt = {
				effect: 'fade',
				spaceBetween: 50,
				loop: isLoop,
				watchOverflow: true,
				lazy: {
					loadPrevNext: true,
				},
				preloadImages: false,
				watchSlidesProgress: true,
				autoplay: {
					delay: isLoop ? 5000 : false,
					disableOnInteraction: false
				},
				pagination: {
					el: swiperPageEl,
					clickable: true,
					dynamicBullets: slidesCount > 6,
					dynamicMainBullets: 6,
					renderBullet (index, className) {
						const title = swiperSlideEl[index].querySelector('.pd-solu__title').innerText;
						return `<span class="${className}" title="${title}">${index + 1}<span class="show-for-sr">${title}</span>${countdownCircle()}</span>`
					}
				},
				on: {
					// Countdown
					init: function (sw) {
						if (isLoop) {
							swiperCountdownInit(sw);
						}
					},
					slideChange: function (sw) {
						if (isLoop) {
							sw.cd && swiperCountdownPlay(sw);
						}
					},
					autoplayStart: function (sw) {
						if (isLoop) {
							sw.cd && swiperCountdownPlay(sw, 'start');
						}
					},
					autoplayStop: function (sw) {
						if (isLoop) {
							sw.cd && swiperCountdownStop(sw);
						}
					},

					// Custom Effect
					// Ref: https://codepen.io/udovichenko/pen/LGeQae
					progress (swiper, progress) {
						customEffect.onProgress(swiper, progress);
						customEffect.onProgress(swiper, progress, 1, null, '.pd-solu__img-box');
					},
	
					touchStart (swiper) {
						customEffect.onTouchStart(swiper);
					},
	
					setTransition (swiper, transition) {
						customEffect.onSetTransition(swiper, transition);
						customEffect.onSetTransition(swiper, transition, '.pd-solu__img-box');
					},
				}
			}

			const options = { ...defaultOpt, ...opt };
			options.on = opt.on ? { ...defaultOpt.on, ...opt.on } : defaultOpt.on;

			swiper = new Swiper(swiperTarget, options);
		}

		// ===================

		// Small: 左右的Slider
		const pdSoluSwiperSmall = function () {
			swiperContEl.setAttribute('dir', '');
			pdSoluSwiperBuild({
				autoHeight: true,
				on: {
					progress(swiper, progress) {
						// customEffect.onProgress(swiper, progress, 1, 'h');
						// customEffect.onProgress(swiper, progress, -1.2, 'h', '.pd-solu__img-box');
						
						customEffect.onProgress(swiper, progress, 0.2, 'h');
						customEffect.onProgress(swiper, progress, -1.2, 'h', '.pd-solu__img-box');
					},

					// 不保留這個，用Pagination更換Slide時，效果會不一樣【原因不明】
					setTransition(swiper, transition) {
						customEffect.onSetTransition(swiper, transition);
						customEffect.onSetTransition(swiper, transition, '.pd-solu__img-box');
					},
				},
			});
		}

		// Large: 左右的Slider（Mobile）
		const pdSoluSwiperLargeHorizontal = function () {
			swiperContEl.setAttribute('dir', '');
			pdSoluSwiperBuild({
				on: {
					progress(swiper, progress) {
						customEffect.onProgress(swiper, progress, 0.3, 'h');
						customEffect.onProgress(swiper, progress, -0.55, 'h', '.pd-solu__img-box');
					},

					// 不保留這個，用Pagination更換Slide時，效果會不一樣【原因不明】
					setTransition(swiper, transition) {
						customEffect.onSetTransition(swiper, transition);
						customEffect.onSetTransition(swiper, transition, '.pd-solu__img-box');
					},
				}
			});
		}

		// Large: 上下的Slider(PC)
		const pdSoluSwiperLargeVertical = function () {
			swiperContEl.setAttribute('dir', 'rtl'); // 垂直，要顛倒，順序與操作順序才會是對的
			pdSoluSwiperBuild({
				direction: 'vertical',
				on: {
					// Custom Effect
					// Ref: https://codepen.io/udovichenko/pen/LGeQae
					progress(swiper, progress) {
						customEffect.onProgress(swiper, progress, 0.2, 'v');
						customEffect.onProgress(swiper, progress, -0.4, 'v', '.pd-solu__img-box');
					},
	
					// 不保留這個，用Pagination更換Slide時，效果會不一樣【原因不明】
					setTransition(swiper, transition) {
						customEffect.onSetTransition(swiper, transition);
						customEffect.onSetTransition(swiper, transition, '.pd-solu__img-box');
					},
				}
			});
		}

		const breakpoint = window.matchMedia('(min-width: 1024px)');
		const breakpointChecker = function() {
			if (swiper !== undefined) {
				swiper.destroy(true, true);
			}

			if (breakpoint.matches) {
				// Large，不是手機板
				if (isMobile) {
					pdSoluSwiperLargeHorizontal();
				} else {
					pdSoluSwiperLargeVertical();
				}
			} else {
				// Small + Medium
				pdSoluSwiperSmall();
			}
		}

		// Start
		breakpointChecker();
		breakpoint.addListener(breakpointChecker);
	}
	window.addEventListener('load', function () {
		if (document.querySelector(pdSoluCarousel) !== null) {
			pageScrollAdd(pdSoluCarousel, pdSoluBuild);
		}
	});
	/* ---------------------------------------- [END] Product Solution | 產品情境 */

	/* ---------------------------------------- [START] Product Recommend | 推薦產品  */
	const pdRecommendCarousel = '#pd-recommend-carousel'; // .swiper-container id

	function pdRecommendBuild() {
		const swiperTarget = pdRecommendCarousel;
		const swiperEl = document.querySelector(swiperTarget).parentElement;
		const swiperPageEl = swiperEl.querySelector('.swiper-pagination');
		const swiperNextEl = swiperEl.querySelector('.swiper-button-next');
		const swiperPrevEl = swiperEl.querySelector('.swiper-button-prev');

		const swiper = new Swiper(swiperTarget, {
			spaceBetween: 20,
			slidesPerView: 2,
			slidesPerGroup: 2,
			// loop: true, // Loop 會有 Checkbox 重複的問題，即使刪掉也沒用
			lazy: true,
			preloadImages: false,
			// [START] Global Pagination + Button (Prev, Next)
			pagination: {
				el: swiperPageEl,
				type: 'fraction',
			},
			navigation: {
				nextEl: swiperNextEl,
				prevEl: swiperPrevEl,
			},
			// [END] Global Pagination + Button (Prev, Next)
			breakpoints: {
				1024: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
				1200: {
					slidesPerView: 4,
					slidesPerGroup: 4,
				}
			},
			on: {
				// init: function(swiper) {
				// 	swiper.slides.forEach(item => {
				// 		if (item.classList.contains('swiper-slide-duplicate')) {
				// 			const input = item.querySelector('input');
				// 			input.removeAttribute('id');
				// 			input.removeAttribute('name');

				// 			const label = item.querySelector('label');
				// 			label.removeAttribute('for');
				// 		}
				// 	});
				// }
			}
		});
	}
	window.addEventListener('load', function () {
		if (document.querySelector(pdRecommendCarousel) !== null) {
			pageScrollAdd(pdRecommendCarousel, pdRecommendBuild);
		}
	});
	/* ---------------------------------------- [END] Product Recommend | 推薦產品 */

	/* ---------------------------------------- [START] Product Support */
	const pdSupportButton = document.querySelector('#pd-support-button-more');
	const pdSupportList = document.querySelector('#pd-support-list');
	const pdSupportClassIsOpen = 'is-open';
	pdSupportButton.addEventListener('click', function() {
		pdSupportButton.classList.toggle(pdSupportClassIsOpen);
		pdSupportList.classList.toggle(pdSupportClassIsOpen);
	});
	/* ---------------------------------------- [END] Product Support */

	/* ---------------------------------------- [START] Product Support - Circle Link */
	// 因為字長不同，影響寬不同，導致平均分配的空間不相同 => JS 解決
	const pdSupportCircleLink = document.querySelectorAll('.svc-list__item');
	function pdSupportCircleLinkResize() {
		let max = 0;

		// 取得寬最大值
		pdSupportCircleLink.forEach((item) => {
			item.style.width = '';
			if (max < item.clientWidth) {
				max = Math.ceil(item.clientWidth) + 1;
			}
		});

		// 給予寬
		pdSupportCircleLink.forEach((item) => {
			item.style.width = max + 'px';
		});
	}
	window.addEventListener('load', pdSupportCircleLinkResize);
	window.addEventListener('resize', throttle(pdSupportCircleLinkResize, 50, 100));
	/* ---------------------------------------- [END] Product Support - Circle Link */

	/* ---------------------------------------- [START] 整頁 Scroll 監測 (After) */
	var pageScrollThrottle = null;
	var pageScrollHandler = function () {
		if (pageScrollCheckList.length === 0) {
			return false;
		} // 因為改成 Page Global 執行，所以不會停止

		for (var i = 0; i < pageScrollCheckList.length; i++) {
			if (isInViewport(pageScrollCheckList[i].el)) {
				pageScrollCheckList[i].fun();
				pageScrollCheckList[i].build = true;
			}
		}
		pageScrollClean();
		// if (pageScrollCheckList.length === 0) {
		// 	off(window, 'scroll', pageScrollThrottle);
		// }
	};

	window.addEventListener('load', function () {
		pageScrollThrottle = throttle(pageScrollHandler, 50, 1000); // 節流作用
		window.addEventListener('scroll', pageScrollThrottle);
		pageScrollHandler();
	});
	/* ---------------------------------------- [END] 整頁 Scroll 監測 (After) */
})(window, document);
